import { render, staticRenderFns } from "./BuildingStaff.vue?vue&type=template&id=445ebaf8&scoped=true&"
import script from "./BuildingStaff.vue?vue&type=script&lang=ts&"
export * from "./BuildingStaff.vue?vue&type=script&lang=ts&"
import style0 from "./BuildingStaff.vue?vue&type=style&index=0&id=445ebaf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445ebaf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('445ebaf8')) {
      api.createRecord('445ebaf8', component.options)
    } else {
      api.reload('445ebaf8', component.options)
    }
    module.hot.accept("./BuildingStaff.vue?vue&type=template&id=445ebaf8&scoped=true&", function () {
      api.rerender('445ebaf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/building/components/BuildingStaff.vue"
export default component.exports